<template>
    <v-container fluid>
        <v-row np-gutters>
            <v-col cols="12" class="mx-0 px-0">
                <template>
                    <v-data-table
                        :headers="headers"
                        :items="players.filter((player) => player.active)"
                        class="elevation-1  py-3 px-3"
                        hide-default-footer
                        :mobile-breakpoint="0"
                        :items-per-page="-1"
                        style="background: #232323; cursor: pointer;"
                        dark
                        @click:row="goToPlayer"
                    >
                        <template v-slot:item.two_points_percentage="{ item }">
                            <span class="font-weight-bold"> {{ option ? `${item.two_points_percentage}%
                                (${item.cum.twoPointsMade} / ${item.cum.twoPointAttempts})` :
                                `${item.two_points_percentage}%` }} </span>
                        </template>
                        <template v-slot:item.three_points_percentage="{ item }">
                            <span class="font-weight-bold"> {{ option ? `${item.three_points_percentage}%
                                (${item.cum.threePointsMade} / ${item.cum.threePointAttempts})` :
                                `${item.three_points_percentage}%` }} </span>
                        </template>
                        <template v-slot:item.free_throw_percentage="{ item }">
                            <span class="font-weight-bold"> {{ option ? `${item.free_throw_percentage}%
                                (${item.cum.freeThrowsMade} / ${item.cum.freeThrowAttempts})` :
                                `${item.free_throw_percentage}%` }} </span>
                        </template>
                        <!-- <template v-slot:item.market="{ item }">
                            <span class="custom-teal-text" style="font-size: 15px;"> {{ item.averagePir.toFixed(2) }}
                            </span>
                            <span v-if="item.pirDates">
                                <v-icon
                                    v-if="item.averagePir > (item.pirDates.slice(0, -1).reduce((a, b) => a + b.pir, 0) / item.pirDates.slice(0, -1).length)"
                                    color="green"
                                > mdi-chevron-double-up </v-icon>
                                <v-icon
                                    v-else-if="item.averagePir < (item.pirDates.slice(0, -1).reduce((a, b) => a + b.pir, 0) / item.pirDates.slice(0, -1).length)"
                                    color="red"
                                > mdi-chevron-double-down </v-icon>
                                <v-icon
                                    v-else-if="item.averagePir === (item.pirDates.slice(0, -1).reduce((a, b) => a + b.pir, 0) / item.pirDates.slice(0, -1).length)"
                                    color="grey"
                                > mdi-arrow-left-right-bold </v-icon>
                            </span>
                            <v-sparkline
                                v-if="item.pirDates"
                                :value="item.pirDates ? item.pirDates.map(element => element.pir) : [0]"
                                :gradient="sparkline.gradient"
                                :smooth="sparkline.radius || false"
                                :padding="sparkline.padding"
                                :line-width="sparkline.width"
                                :stroke-linecap="sparkline.lineCap"
                                :gradient-direction="sparkline.gradientDirection"
                                :fill="sparkline.fill"
                                :type="sparkline.type"
                                :auto-line-width="sparkline.autoLineWidth"
                                height="50"
                                auto-draw
                                color="black"
                            />
                        </template> -->
                        <template v-slot:item.playTimeInSecs="{ item }">
                            <span>
                                {{ option === 0 ? secToMinutesSeconds(item.avg.playTimeInSecs) :
                                    secToMinutesSeconds(item.cum.playTimeInSecs) }}
                            </span>
                        </template>
                    </v-data-table>
                </template>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    const gradients = [
        ['#ffd200'],
        ['#ffd200'],
        ['red', 'teal', 'yellow'],
        ['purple', 'violet'],
        ['#ffd200', '#F0F', '#FF0'],
        ['#f72047', '#ffd200', '#ffd200']
    ]

    export default {
        props: {
            players: {
                type: Array,
                default: () => []
            },
            option: {
                type: Number,
                default: 0
            },
            generic: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                headers: [
                    { text: 'Player', value: 'player', align: 'start' },
                    {
                        text: '# Number',
                        value: 'jersey',
                        align: 'center'
                    },
                    { text: 'GP', value: 'gp', align: 'start' },
                    { text: 'Pts', value: 'points' },
                    { text: '2P%', value: 'two_points_percentage', width: '150px', align: 'center' },
                    { text: '3P%', value: 'three_points_percentage', width: '150px', align: 'center' },
                    { text: 'FT%', value: 'free_throw_percentage', width: '150px', align: 'center' },
                    { text: 'OR', value: 'offensiveRebounds', align: 'start' },
                    { text: 'DR', value: 'defensiveRebounds', align: 'start' },
                    { text: 'TR', value: 'rebounds', align: 'start' },
                    { text: 'AST', value: 'assists', align: 'start' },
                    { text: 'STL', value: 'steals', align: 'start' },
                    { text: 'TO', value: 'turnovers', align: 'start' },
                    { text: 'BLK', value: 'blockedShots', align: 'start' },
                    { text: 'FC', value: 'personalFouls', align: 'start' },
                    { text: 'EFF', value: 'pir', align: 'center' }
                    // { text: 'Min', value: 'playTimeInSecs', align: 'center', width: '100px' }
                ],
                maxGames: 1,
                sparkline: {
                    width: 2,
                    radius: 10,
                    padding: 8,
                    lineCap: 'round',
                    gradient: gradients[5],
                    gradientDirection: 'top',
                    gradients,
                    fill: true,
                    type: 'trend',
                    autoLineWidth: false
                }
            }
        },
        watch: {
            generic: {
                handler() {
                    if (this.generic) {
                        this.headers.splice(1, 0, { text: 'Team', value: 'team' })
                    }
                }
            },
            option: {
                handler() {
                    this.prepareData()
                }
            },
            players: {
                handler() {
                    this.prepareData()
                }
            }
        },
        created() {
            if (this.generic) {
                this.headers.splice(1, 0, { text: 'Team', value: 'team' })
            }
            // Prepare data on component creation so initial players don't render undefined
            this.prepareData()
        },
        methods: {
            goToPlayer(player) {
                this.$router.push({ name: 'Player', params: { id: player.id } })
            },
            secToMinutesSeconds(ms) {
                if (ms < 0) return '-'
                if (typeof ms !== 'number' || isNaN(ms)) return '-'
                const minutes = Math.floor(ms / 60)
                const seconds = Math.floor(ms % 60)
                if (isNaN(minutes) || isNaN(seconds)) return '-'
                return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
            },
            toFixedSafe(v, digits = 1) {
                const n = Number(v)
                return Number.isFinite(n) ? n.toFixed(digits) : '0.0'
            },
            pctSafe(made, attempts, digits = 1) {
                const m = Number(made) || 0
                const a = Number(attempts) || 0
                if (a === 0) return (0).toFixed(digits)
                return ((m / a) * 100).toFixed(digits)
            },
            numOrZero(v) {
                const n = Number(v)
                return Number.isFinite(n) ? n : 0
            },
            prepareData() {
                if (!Array.isArray(this.players)) return

                this.players.forEach(player => {
                    const avg = player?.avg || {}
                    const cum = player?.cum || {}
                    const statsLen = Array.isArray(player?.stats) ? player.stats.length : 0
                    if (statsLen > this.maxGames) this.maxGames = statsLen

                    // Ensure cum and avg objects exist and numeric fields default to 0
                    player.cum = Object.assign({
                        twoPointsMade: 0,
                        twoPointAttempts: 0,
                        threePointsMade: 0,
                        threePointAttempts: 0,
                        freeThrowsMade: 0,
                        freeThrowAttempts: 0,
                        points: 0,
                        offensiveRebounds: 0,
                        defensiveRebounds: 0,
                        rebounds: 0,
                        assists: 0,
                        steals: 0,
                        turnovers: 0,
                        blockedShots: 0,
                        personalFouls: 0,
                        pir: 0,
                        playTimeInSecs: 0
                    }, cum)

                    player.avg = Object.assign({
                        twoPointsMade: 0,
                        twoPointAttempts: 0,
                        threePointsMade: 0,
                        threePointAttempts: 0,
                        freeThrowsMade: 0,
                        freeThrowAttempts: 0,
                        points: 0,
                        offensiveRebounds: 0,
                        defensiveRebounds: 0,
                        rebounds: 0,
                        assists: 0,
                        steals: 0,
                        turnovers: 0,
                        blockedShots: 0,
                        personalFouls: 0,
                        pir: 0,
                        playTimeInSecs: 0
                    }, avg)

                    // Ensure fields exist to prevent template errors
                    player.player = `${player.name || ''} ${player.surname || ''}`.trim()
                    player.gp = statsLen

                    // Points and common stats
                    player.points = this.option ? this.numOrZero(cum.points) : this.toFixedSafe(avg.points, 1)
                    player.offensiveRebounds = this.option ? this.numOrZero(cum.offensiveRebounds) : this.toFixedSafe(avg.offensiveRebounds, 1)
                    player.defensiveRebounds = this.option ? this.numOrZero(cum.defensiveRebounds) : this.toFixedSafe(avg.defensiveRebounds, 1)
                    player.rebounds = this.option ? this.numOrZero(cum.rebounds) : this.toFixedSafe(avg.rebounds, 1)
                    player.assists = this.option ? this.numOrZero(cum.assists) : this.toFixedSafe(avg.assists, 1)
                    player.steals = this.option ? this.numOrZero(cum.steals) : this.toFixedSafe(avg.steals, 1)
                    player.turnovers = this.option ? this.numOrZero(cum.turnovers) : this.toFixedSafe(avg.turnovers, 1)
                    player.blockedShots = this.option ? this.numOrZero(cum.blockedShots) : this.toFixedSafe(avg.blockedShots, 1)
                    player.personalFouls = this.option ? this.numOrZero(cum.personalFouls) : this.toFixedSafe(avg.personalFouls, 1)

                    // Percentages
                    player.two_points_percentage = this.option
                        ? this.pctSafe(cum.twoPointsMade, cum.twoPointAttempts, 1)
                        : this.pctSafe(avg.twoPointsMade, avg.twoPointAttempts, 1)

                    player.free_throw_percentage = this.option
                        ? this.pctSafe(cum.freeThrowsMade, cum.freeThrowAttempts, 1)
                        : this.pctSafe(avg.freeThrowsMade, avg.freeThrowAttempts, 1)

                    player.three_points_percentage = this.option
                        ? this.pctSafe(cum.threePointsMade, cum.threePointAttempts, 1)
                        : this.pctSafe(avg.threePointsMade, avg.threePointAttempts, 1)

                    // PIR and play time
                    player.pir = this.option ? this.numOrZero(cum.pir) : this.toFixedSafe(avg.pir, 1)
                    // Ensure averagePir always exists to avoid template toFixed error
                    if (player.averagePir == null) player.averagePir = 0

                    // Normalize play time
                    player.playTimeInSecs = this.option
                        ? this.numOrZero(cum.playTimeInSecs)
                        : this.numOrZero(avg.playTimeInSecs)
                })
            }
        }
    }
</script>

<style scoped>
table > tbody > tr > td:nth-child(1),
table > thead > tr > th:nth-child(1) {
    position: sticky !important;
    left: 0;
    background: white;
}
</style>
